const navUtils = {
  defineComp: item => {
    if (item.cap) return 'nav-cap'
    if (item.children) return 'nav-group'
    return 'nav-link'
  }
}

export default navUtils